import type {ReactNode} from 'react';
import {UnitSpecKey} from '../../model';
import {AppIcon, FaAreaIcon, FaBathIcon, FaBedIcon, FaHouseChimneyIcon} from '../icon';

export function unitSpecIcon(key: UnitSpecKey, size: 'sm' | 'md' = 'md'): ReactNode {
  switch (key) {
    case UnitSpecKey.Bedrooms:
      return <AppIcon icon={FaBedIcon} size={size === 'sm' ? 'sm' : undefined} aria-hidden />;
    case UnitSpecKey.Bathrooms:
      return <AppIcon icon={FaBathIcon} size={size === 'sm' ? 'sm' : undefined} aria-hidden />;
    case UnitSpecKey.Area:
      return <AppIcon icon={FaAreaIcon} size={size === 'sm' ? 'sm' : undefined} aria-hidden />;
    case UnitSpecKey.DesignCategory:
      return <AppIcon icon={FaHouseChimneyIcon} size={size === 'sm' ? 'sm' : undefined} aria-hidden />;
  }
}
